exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\nag-grid-angular {\n  width: 800px;\n  height: 200px;\n  border: 5px #0000ff solid; }\n\n.ag-row,\n.ag-cell {\n  height: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/grid-page/grid-page.scss
// module id = ../../../../../src/app/sample/containers/grid-page/grid-page.scss
// module chunks = main